<!-- 
// ============================================
// 11. ProductSpecifications.vue
// ============================================ -->
<template>
    <div class="info-block">
        <h3>{{ $t('product.specifications') }}</h3>
        <div class="row specs-table">
            <div class="col-12 col-md-6 mb-4">
                <div class="row">
                    <div class="col-6">{{ $t('product.condition') }}</div>
                    <div class="col-6 font-weight-bold">{{ getConditionLabel(product.state) }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductSpecifications',
    props: {
        product: {
            type: Object,
            required: true
        }
    },
    methods: {
        getConditionLabel(condition) {
            const conditions = {
                new: this.$t('condition.new') || 'Neuf',
                used: this.$t('condition.used') || 'Occasion',
                refurbished: this.$t('condition.refurbished') || 'Reconditionné'
            };
            return conditions[condition] || condition;
        }
    }
};
</script>

/* ============================================
   11. ProductSpecifications.vue
   ============================================ */
<style scoped>
.info-block {
    margin-top: 30px;
    margin-bottom: 30px;
    padding-bottom: 30px;
    border-bottom: 1px solid #e8e8e8;
}

.info-block:last-of-type {
    border-bottom: none;
    margin-bottom: 0;
}

.info-block h3 {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 15px;
    color: var(--color-3);
}

.specs-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
}

.specs-table tr {
    border-bottom: 1px solid #e8e8e8;
}

.specs-table tr:last-child {
    border-bottom: none;
}

.specs-table td {
    padding: 12px 0;
}

@media (max-width: 768px) {
    .specs-table td {
        font-size: 14px;
    }
}

@media (max-width: 576px) {
    .info-block {
        margin-bottom: 25px;
        padding-bottom: 25px;
    }

    .info-block h3 {
        font-size: 16px;
    }
}
</style>
